// extracted by mini-css-extract-plugin
export default {"input":"SearchBar_input__8pEF2","search":"SearchBar_search__IqOhu","searchButton":"SearchBar_searchButton__2dnOs","buscar":"SearchBar_buscar__qg1cY"};